export const TXTWCL_No_Games_to_Show = {
  "id": "TXTWCL_No_Games_to_Show",
  "defaultMessage": "No Games to Show"
} as const;

export const TXTCLI_Confirm = {
  "id": "TXTCLI_Confirm",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Confirm"
} as const;

export const TXTWCL_Cancel = {
  "id": "TXTWCL_Cancel",
  "defaultMessage": "Cancel"
} as const;

export const TXTCLI_Cash__games = {
  "id": "TXTCLI_Cash__games",
  "defaultMessage": "Cash"
} as const;

export const TXTCLI_Flash_HoldXem = {
  "id": "TXTCLI_Flash_HoldXem",
  "defaultMessage": "Flash Hold'em"
} as const;

export const TXTCLI_HoldXem = {
  "id": "TXTCLI_HoldXem",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Hold'em"
} as const;

export const TXTCLI_HoldXem_Six = {
  "id": "TXTCLI_HoldXem_Six",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Hold'em Six"
} as const;

export const TXTCLI_Max_HoldXem = {
  "id": "TXTCLI_Max_HoldXem",
  "defaultMessage": "Max Hold'em"
} as const;

export const TXTCLI_Omaha = {
  "id": "TXTCLI_Omaha",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Omaha"
} as const;

export const TXTCLI_Spin_X_Go = {
  "id": "TXTCLI_Spin_X_Go",
  "defaultMessage": "Spin & Go"
} as const;

export const TXTCLI_Tourney = {
  "id": "TXTCLI_Tourney",
  "defaultMessage": "Tourney"
} as const;

export const TXTCLI_Take_Your_Seat = {
  "id": "TXTCLI_Take_Your_Seat",
  "defaultMessage": "Take Your Seat"
} as const;

export const TXTCLI_Open = {
  "id": "TXTCLI_Open",
  "defaultMessage": "Open"
} as const;

export const TXTCLI_Unregister = {
  "id": "TXTCLI_Unregister",
  "defaultMessage": "Unregister"
} as const;

export const TXTCLI_Your_registered_and_active_gam_ELL = {
  "id": "TXTCLI_Your_registered_and_active_gam_ELL",
  "defaultMessage": "Your registered and active games will be displayed here"
} as const;

export const TXTCLI_Take_seat = {
  "id": "TXTCLI_Take_seat",
  "defaultMessage": "Take seat"
} as const;

export const TXTCLI_Zoom = {
  "id": "TXTCLI_Zoom",
  "defaultMessage": "Zoom"
} as const;

export const TXTCLI_ON_DEMAND = {
  "id": "TXTCLI_ON_DEMAND",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "ON DEMAND"
} as const;